import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import '../../components/balancestyle.scss';

class Announcement extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { postKey, post } = this.props;
    this.renderPostBody();
  }

  renderPostBody() {
    const { postKey, post } = this.props;
    let postBody;
    let bodyEl;
    let useBody;
    if (post && post.body) {
      if (post.body.startsWith('<')) {
        useBody = post.body;
      } else {
        useBody = '<p>' + post.body + '</p>';
      }
      postBody = new DOMParser().parseFromString(useBody, 'text/html');
    }
    if (postKey) {
      bodyEl = document.getElementById(postKey);
    }
    if (postBody && bodyEl) {
      document.getElementById(postKey).append(...postBody.body.children);
    }
  }

  render() {
    const { postKey, post, alone } = this.props;
    let postTime;
    if (post && post.time) {
      postTime = moment.unix(post.time).calendar(null, {
        sameDay: '[Today]',
        nextDay: '[Tomorrow]',
        nextWeek: 'L',
        lastDay: '[Yesterday]',
        lastWeek: 'L',
        sameElse: 'L',
      });
    }

    let buttonClass = 'vlt-button dark-b';
    if (post && post.linkStyle) {
      switch (post.linkStyle) {
        case 'dark':
          buttonClass = 'vlt-button dark-b';
          break;
        case 'light':
          buttonClass = 'vlt-button';
          break;
        default:
          buttonClass = 'vlt-button dark-b';
          break;
      }
    }

    return (
      <div
        className={
          alone ? (
            'cell panel small-12 medium-12 large-12 ann ' + post.accent
          ) : (
            'cell panel small-12 medium-6 large-6 ann ' + post.accent
          )
        }
      >
        <div className="ann-top">
          <div className="ann-cat">
            <span>
              {post.category || ''}
            </span>
            <span>
              {postTime || ''}
            </span>
          </div>
          <div className="ann-head">
            <h2>{post.header || ''}</h2>
          </div>
        </div>
        <div className="ann-bod" id={postKey} />
        <div className="ann-act">
          {post.linkText && post.linkHref ? (
            <a href={post.linkHref} className={buttonClass}>
              <span>{post.linkText}</span>
            </a>
          ) : (
            null
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps)(Announcement);
